/* ============================================================
   CiemnaSzyba — drobne UI
   Szacowana dostawa, wysokość nagłówka, sticky CTA, licznik koszyka,
   poświata w hero.
   ============================================================ */
(function () {
  "use strict";

  var MONTHS = ["stycznia", "lutego", "marca", "kwietnia", "maja", "czerwca",
                "lipca", "sierpnia", "września", "października", "listopada", "grudnia"];

  /* ---- szacowana dostawa -------------------------------------
     ⚠ MUSI zostać po stronie klienta. Shopify cache'uje HTML
     storefrontu, więc `'now' | date` w Liquid zamarza i klient
     zobaczy termin z przeszłości. Okno: dziś+7 … dziś+16. */
  function deliveryText() {
    var a = new Date(); a.setDate(a.getDate() + 7);
    var b = new Date(); b.setDate(b.getDate() + 16);
    if (a.getMonth() === b.getMonth()) {
      return a.getDate() + "–" + b.getDate() + " " + MONTHS[b.getMonth()];
    }
    return a.getDate() + " " + MONTHS[a.getMonth()] + " – " + b.getDate() + " " + MONTHS[b.getMonth()];
  }

  function initDelivery() {
    CS.$$("[data-cs-delivery]").forEach(function (el) {
      el.textContent = "Szacowana dostawa: " + deliveryText();
    });
  }

  /* ---- wysokość nagłówka -------------------------------------
     Źródło miało na sztywno scroll-padding-top:92px, co zakłada
     widoczny pasek informacyjny. Po jego ukryciu kotwica
     #konfigurator uciekała o ~40 px. Mierzymy realnie. */
  function initHeaderHeight() {
    var header = document.querySelector("[data-cs-header]");
    if (!header) return null;
    function apply() {
      document.documentElement.style.setProperty("--cs-header-h", Math.round(header.getBoundingClientRect().height) + "px");
    }
    apply();
    if (typeof ResizeObserver === "undefined") return null;
    var ro = new ResizeObserver(apply);
    ro.observe(header);
    return ro;
  }

  /* ---- sticky CTA (mobile) -----------------------------------
     PRZYCZYNA „nie działa na telefonie”: pasek renderował się poprawnie — fixed,
     z-index 150, żaden przodek nie łamał `position: fixed`, nic go nie zakrywało
     — ale przy `bottom: 0` wchodził POD pasek podglądu motywu Shopify. Zmierzone:
     68 z 72 px wysokości było zasłonięte, czyli w podglądzie wyglądał na nieobecny.
     Stąd --cs-preview-h: mierzymy #PBarNextFrameWrapper i podnosimy pasek
     dokładnie o jego wysokość. Na opublikowanym sklepie tego paska nie ma
     i offset wynosi 0, więc produkcja zachowuje się jak dotąd.

     Przy okazji poprawki zachowania:
     • odniesieniem jest przycisk „Dodaj do koszyka”, a nie dolna krawędź CAŁEGO
       formularza;
     • pasek jest widoczny zawsze, gdy tego przycisku NIE ma w kadrze — także
       gdy stoi się NAD nim, w selektorze auta (patrz komentarz przy update());
     • pasek chowa się, gdy w kadr wchodzi stopka, żeby jej nie zasłaniać
       (wcześniej zostawał widoczny do samego końca strony). */
  function initStickyCta() {
    var bar = document.querySelector("[data-cs-sticky]");
    var form = document.getElementById("konfigurator");
    if (!bar || !form) return function () {};
    var cta = form.querySelector("[data-cs-submit]") || form;
    var footer = document.querySelector(".cs-footer");

    /* Pasek podglądu motywu jest fixed przy dolnej krawędzi i nachodziłby na CTA.
       Na opublikowanym sklepie go nie ma, więc wartość zostaje 0. */
    function applyPreviewOffset() {
      var pb = document.getElementById("PBarNextFrameWrapper");
      var h = pb ? Math.round(pb.getBoundingClientRect().height) : 0;
      bar.style.setProperty("--cs-preview-h", h + "px");
    }

    /* ⚠ Warunkiem jest „przycisku NIE MA w kadrze", w OBIE strony — nie
       „przycisk zjechał za górną krawędź".
       BYŁO `cta.getBoundingClientRect().bottom < 0`, czyli pasek pokazywał się
       dopiero PO minięciu przycisku. Przez cały selektor auta — najdłuższy
       fragment strony, na którym klient stoi najdłużej — przycisk był jeszcze
       NIŻEJ, więc na ekranie nie było żadnego CTA.
       Teraz pasek znika wyłącznie wtedy, gdy prawdziwy przycisk jest widoczny;
       nad nim i pod nim jest obecny.
       Test bez przewijania (podgląd nie renderuje): ujemny `margin-top` na
       `main` przesuwa layout, po czym `dispatchEvent(new Event("scroll"))`
       wymusza przeliczenie — margines nie tworzy kontekstu nakładania. */
    function update() {
      var r = cta.getBoundingClientRect();
      var ctaWKadrze = r.bottom > 0 && r.top < window.innerHeight;
      var stopkaWKadrze = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      bar.hidden = !(CS.isMobile() && !ctaWKadrze && !stopkaWKadrze);
    }
    function onResize() { applyPreviewOffset(); update(); }

    applyPreviewOffset();
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", onResize);
    CS.mobileMQ.addEventListener("change", onResize);

    return function () {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", onResize);
      CS.mobileMQ.removeEventListener("change", onResize);
    };
  }

  /* ---- nawigacja pod hamburgerem (mobile) --------------------
     Rejestracja na [data-cs-burger], a nie na sekcji nagłówka — patrz §4.11
     PRZEKAZANIE: `mounted` w cs-core.js kluczuje WeakMap samym elementem,
     więc druga onSection na tym samym węźle byłaby po cichu pominięta. */
  function initNav(btn) {
    var header = btn.closest(".cs-header");
    var nav = header && header.querySelector("[data-cs-nav]");
    if (!header || !nav) return function () {};

    function otwarte() { return btn.getAttribute("aria-expanded") === "true"; }
    function ustaw(v) {
      if (v) {
        /* Docelowa wysokość animacji rozwijania. scrollHeight raportuje pełną
           treść mimo max-height: 0, więc mierzymy tuż przed otwarciem —
           animacja jedzie do realnej wysokości panelu, a nie do zgadywanej. */
        nav.style.setProperty("--cs-nav-h", nav.scrollHeight + "px");
      }
      btn.setAttribute("aria-expanded", v ? "true" : "false");
      header.classList.toggle("is-nav-open", v);
    }
    /* Focus wraca na przycisk, gdy zamykamy z klawiatury albo gdy fokus siedział
       w menu. Przy kliknięciu poza menu NIE odbieramy fokusu klikniętemu
       elementowi — to by walczyło z intencją użytkownika. */
    function zamknij(wymusFocus) {
      if (!otwarte()) return;
      var bylWSrodku = nav.contains(document.activeElement);
      ustaw(false);
      if (wymusFocus || bylWSrodku) btn.focus();
    }

    function onBtn() {
      if (otwarte()) { zamknij(true); return; }
      ustaw(true);
      /* Focus na pierwszym linku NATYCHMIAST, nie po animacji — w stanie
         otwartym visibility przełącza się bez opóźnienia. Odczyt offsetHeight
         wymusza przeliczenie stylu; bez niego focus() trafiłby jeszcze
         w element o visibility: hidden i zostałby zignorowany. */
      void nav.offsetHeight;
      var pierwszy = nav.querySelector("a");
      if (pierwszy) pierwszy.focus();
    }
    function onKey(e) { if (e.key === "Escape" || e.key === "Esc") zamknij(true); }
    function onDoc(e) { if (!header.contains(e.target)) zamknij(false); }
    function onNav(e) { if (e.target.closest("a")) zamknij(false); }
    /* Powrót na desktop zostawiłby aria-expanded="true" przy widocznej,
       poziomej nawigacji — mylące dla czytnika ekranu. */
    function onMQ() { if (!CS.mobileMQ.matches) zamknij(false); }

    btn.addEventListener("click", onBtn);
    document.addEventListener("keydown", onKey);
    document.addEventListener("click", onDoc);
    nav.addEventListener("click", onNav);
    CS.mobileMQ.addEventListener("change", onMQ);
    window.addEventListener("resize", onMQ, { passive: true });

    return function () {
      btn.removeEventListener("click", onBtn);
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("click", onDoc);
      nav.removeEventListener("click", onNav);
      CS.mobileMQ.removeEventListener("change", onMQ);
      window.removeEventListener("resize", onMQ);
    };
  }

  CS.onSection("[data-cs-burger]", initNav);

  /* ---- poświata w hero ---------------------------------------
     Czysta dekoracja. Wyłączona przy prefers-reduced-motion
     i na urządzeniach bez precyzyjnego wskaźnika. */
  function initHeroGlow() {
    var glow = document.querySelector("[data-cs-glow]");
    if (!glow) return function () {};
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return function () {};
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return function () {};

    var host = glow.closest("section");
    if (!host) return function () {};

    function move(e) {
      var r = host.getBoundingClientRect();
      glow.style.opacity = "1";
      glow.style.transform = "translate3d(" + (e.clientX - r.left) + "px," + (e.clientY - r.top) + "px,0)";
    }
    function leave() { glow.style.opacity = "0"; }

    host.addEventListener("pointermove", move, { passive: true });
    host.addEventListener("pointerleave", leave, { passive: true });
    return function () {
      host.removeEventListener("pointermove", move);
      host.removeEventListener("pointerleave", leave);
    };
  }

  /* ---- tickery (mobile) --------------------------------------
     Pasek informacyjny i pasek zaufania zawijały się na kilka linii.
     Samą pętlę robi CSS (dwie identyczne grupy w __track + translateX(-50%)),
     tutaj są tylko dwie rzeczy, których CSS nie umie:
       (a) tempo liczone z szerokości grupy, żeby prędkość nie zależała od
           długości tekstów wpisanych w adminie,
       (b) pauza przy dotknięciu.
     Na desktopie grupa ma display: contents, więc nie ma boksu i offsetWidth
     wynosi 0 — wtedy nic nie ustawiamy, a animacji i tak nie ma. */
  var TICKER_SPEED = 55; /* px/s */

  function initTicker(inner) {
    var track = inner.firstElementChild;
    var group = track && track.firstElementChild;
    if (!group) return function () {};

    function applyDuration() {
      var w = group.offsetWidth;
      if (!w) return;
      inner.style.setProperty("--cs-ticker-dur", (w / TICKER_SPEED).toFixed(2) + "s");
    }
    function pause() { inner.classList.add("is-ticker-paused"); }
    function resume() { inner.classList.remove("is-ticker-paused"); }

    applyDuration();

    var ro = typeof ResizeObserver !== "undefined" ? new ResizeObserver(applyDuration) : null;
    if (ro) ro.observe(inner);
    CS.mobileMQ.addEventListener("change", applyDuration);

    inner.addEventListener("pointerdown", pause);
    inner.addEventListener("pointerup", resume);
    inner.addEventListener("pointercancel", resume);
    inner.addEventListener("pointerleave", resume);

    return function () {
      if (ro) ro.disconnect();
      CS.mobileMQ.removeEventListener("change", applyDuration);
      inner.removeEventListener("pointerdown", pause);
      inner.removeEventListener("pointerup", resume);
      inner.removeEventListener("pointercancel", resume);
      inner.removeEventListener("pointerleave", resume);
    };
  }

  CS.onSection("[data-cs-ticker]", initTicker);

  /* ---- podgląd zakresu: miejsce zależne od breakpointu -------
     Na mobile podgląd ma stać pod nagłówkiem „Zakres okien”, czyli WEWNĄTRZ
     formularza; na desktopie zostaje w lepkiej kolumnie galerii. To dwa różne
     kontenery, a `order` działa tylko między rodzeństwem — samym CSS-em się
     tego nie zrobi. Przenosimy więc jeden węzeł tam i z powrotem.

     Dlaczego nie druga kopia w HTML: cs-configurator.js bierze
     `root.querySelector("[data-cs-coverage]")`, czyli tylko pierwszy
     egzemplarz, więc drugi nigdy by się nie odświeżał.

     Przenosiny nie zrywają referencji trzymanych przez konfigurator —
     to wciąż ten sam element, zmienia się wyłącznie rodzic.

     ⚠ Rejestrujemy się na GNIEŹDZIE, nie na [data-cs-product]. `mounted`
     w cs-core.js to WeakMap kluczowany samym elementem, nie parą
     element+selektor, więc druga rejestracja na tym samym elemencie jest
     po cichu pomijana — a [data-cs-product] zajmuje już cs-configurator.js,
     ładowany wcześniej. Ten init nigdy by się nie wykonał. */
  function initCoveragePlacement(slot) {
    var root = slot.closest("[data-cs-product]");
    var box = root && root.querySelector(".cs-hero__coverage");
    if (!box) return function () {};
    var home = box.parentNode;            /* .cs-hero__gallery, stan wyjściowy */

    var lastW = -1;

    function place() {
      var target = CS.mobileMQ.matches ? slot : home;
      if (box.parentNode !== target) target.appendChild(box);
    }
    function onWidth(entries) {
      var w = entries && entries[0] ? Math.round(entries[0].contentRect.width) : root.clientWidth;
      if (w === lastW) return;   /* przenosiny zmieniają wysokość, nie szerokość — pętli RO nie ma */
      lastW = w;
      place();
    }

    place();

    /* TRZY niezależne wyzwalacze, celowo z nadmiarem. `place` jest idempotentne
       i kosztuje jedno porównanie, więc nadmiar nic nie kosztuje, a pomyłka
       kosztuje dużo: podgląd zostaje po niewłaściwej stronie breakpointu.
       (W podglądzie motywu nie odpala ani `change` na MQ, ani ResizeObserver —
       ten sandbox nie kręci pętli renderowania. Na normalnej przeglądarce
       odpalają wszystkie trzy.) */
    CS.mobileMQ.addEventListener("change", place);
    window.addEventListener("resize", place, { passive: true });
    var ro = typeof ResizeObserver !== "undefined" ? new ResizeObserver(onWidth) : null;
    if (ro) ro.observe(root);

    return function () {
      CS.mobileMQ.removeEventListener("change", place);
      window.removeEventListener("resize", place);
      if (ro) ro.disconnect();
    };
  }

  CS.onSection("[data-cs-coverage-slot]", initCoveragePlacement);

  /* ---- licznik koszyka --------------------------------------- */
  function refreshCartCount() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        CS.$$("[data-cs-cart-count]").forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () { /* licznik nie jest krytyczny */ });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initDelivery();
    initHeaderHeight();
    initStickyCta();
    initHeroGlow();
  });

  window.CSUi = { refreshCartCount: refreshCartCount, deliveryText: deliveryText };
})();
